import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Editor } from 'slate';
var CodeBlock = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(CodeBlock, _React$PureComponent);
  var _super = _createSuper(CodeBlock);
  function CodeBlock() {
    var _this;
    _classCallCheck(this, CodeBlock);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.onChange = function (event) {
      var editor = _this.props.editor;
      var language = event.target.value;
      Editor.setNodes(editor, {
        data: {
          syntax: language
        }
      }, {
        match: {
          type: 'code_block'
        }
      });
    };
    return _this;
  }
  _createClass(CodeBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        attributes = _this$props.attributes,
        children = _this$props.children,
        node = _this$props.node,
        isSelected = _this$props.isSelected,
        readOnly = _this$props.readOnly;
      var language = node.data.syntax;
      return /*#__PURE__*/React.createElement("div", {
        className: 'code-container'
      }, /*#__PURE__*/React.createElement("pre", Object.assign({
        className: 'code'
      }, attributes), /*#__PURE__*/React.createElement("code", null, children)), isSelected ? /*#__PURE__*/React.createElement(LanguageSet, {
        disabled: readOnly,
        language: language,
        onChange: this.onChange
      }) : null);
    }
  }]);
  return CodeBlock;
}(React.PureComponent);
var LanguageSet = /*#__PURE__*/function (_React$PureComponent2) {
  _inherits(LanguageSet, _React$PureComponent2);
  var _super2 = _createSuper(LanguageSet);
  function LanguageSet() {
    var _this2;
    _classCallCheck(this, LanguageSet);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _this2.stopPropagation = function (event) {
      event.stopPropagation();
    };
    return _this2;
  }
  _createClass(LanguageSet, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Compat chrome browser in windows, stop propagation to prevent emit the click event added to document
      this.selector.addEventListener('click', this.stopPropagation);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.selector.removeEventListener('click', this.stopPropagation);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement("div", {
        contentEditable: false,
        className: "language-type"
      }, /*#__PURE__*/React.createElement("select", {
        ref: function ref(_ref) {
          return _this3.selector = _ref;
        },
        value: this.props.language,
        disabled: this.props.disabled,
        name: "language",
        onInput: function onInput(event) {
          return event.stopPropagation();
        },
        onChange: this.props.onChange
      }, /*#__PURE__*/React.createElement("option", {
        value: "none"
      }, "Text"), /*#__PURE__*/React.createElement("option", {
        value: "html"
      }, "HTML"), /*#__PURE__*/React.createElement("option", {
        value: "css"
      }, "CSS"), /*#__PURE__*/React.createElement("option", {
        value: "javascript"
      }, "Javascript"), /*#__PURE__*/React.createElement("option", {
        value: "c"
      }, "C"), /*#__PURE__*/React.createElement("option", {
        value: "cpp"
      }, "C++"), /*#__PURE__*/React.createElement("option", {
        value: "csharp"
      }, "C#"), /*#__PURE__*/React.createElement("option", {
        value: "java"
      }, "Java"), /*#__PURE__*/React.createElement("option", {
        value: "python"
      }, "Python"), /*#__PURE__*/React.createElement("option", {
        value: "sql"
      }, "Sql"), /*#__PURE__*/React.createElement("option", {
        value: "swift"
      }, "Swift"), /*#__PURE__*/React.createElement("option", {
        value: "json"
      }, "JSON")));
    }
  }]);
  return LanguageSet;
}(React.PureComponent);
export default CodeBlock;